import { render, staticRenderFns } from "./EmailNotificationDialog.vue?vue&type=template&id=558e1f57&scoped=true"
import script from "./EmailNotificationDialog.vue?vue&type=script&lang=js"
export * from "./EmailNotificationDialog.vue?vue&type=script&lang=js"
import style0 from "./EmailNotificationDialog.vue?vue&type=style&index=0&id=558e1f57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558e1f57",
  null
  
)

export default component.exports